export default "__VITE_ASSET__BeJhkRQn__"